import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export class FowlSlotBonusResult extends BonusResult {
    public resultType = "FowlSlotBonusResult";
    public totalSpins: number;
}
